import { useRef, useState } from 'react';

import { ContentCopy, OpenInNew } from '@mui/icons-material';
import { Button, TableCell, TableRow, Tooltip } from '@mui/material';
import axios from 'axios';
import copy from 'copy-to-clipboard';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { useHistory, useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';
import { useContainer } from 'unstated-next';

import { OIDC_LOGIN_REDIRECT_PATH } from '../../../../config/apiPaths';
import getTimeFormatFromLocale from '../../../../utils/getTimeFormatFromLocale';
import { getUserUuidHeaders } from '../../../../utils/httpUtils';
import { getUrls } from '../../../../utils/url';
import AdminSsoContainer, { type OidcIdpRecordClient, SsoView } from '../../AdminSsoContainer';




interface SsoTableRowProps {
    data: OidcIdpRecordClient;
}

const StyledTableRow = styled(TableRow)``;

const StyledTableCell = styled(TableCell)`
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
`;

const { format: timeFormat } = getTimeFormatFromLocale();

const SsoTableRow: React.FC<SsoTableRowProps> = ({ data }) => {
    const { display_name, id: idpId, updated_at: updatedAt } = data;
    const lastUpdated = format(new Date(updatedAt!), timeFormat);
    const history = useHistory();
    const { path } = useRouteMatch();
    const { setSelectedIdp, setIdpId, view,
        setView } = useContainer(AdminSsoContainer);
    const { t } = useTranslation('admin_settings');
    const { api } = getUrls();
   const { t:tCommon } = useTranslation('common');

    const [hasCopied, setHasCopied] = useState(false);

    const [hasLaunched, setHasLaunched] = useState(false);

    const timeoutRef = useRef<number>();

    const copyTooltipTitle = hasCopied ? t('copied') : t('copy');
    const openTooltipTitle = hasLaunched ? t('opened') : t('open');

    const fetchRedirectUrl = async () => {
        const redirectUrlEndpoint = `${api}${OIDC_LOGIN_REDIRECT_PATH(data.id)}?target=debug`;
        const localUserUuid = window.localStorage.getItem('user_uuid');
        try {
        const response = await axios.post(redirectUrlEndpoint, {}, {
            headers: getUserUuidHeaders(localUserUuid!)
        });
        return response.data.url;
        } catch (error) {
        console.error('Error during OIDC login redirect:', error);
        return null;
        }
    };


    const onCopyURL = () => {
        fetchRedirectUrl().then(redirectUrl => {
            if (redirectUrl) {
                window.clearTimeout(timeoutRef.current);

                copy(redirectUrl);
        
                setHasCopied(true);
        
                timeoutRef.current = window.setTimeout(() => {
                    setHasCopied(false);
                }, 2000);
            }
        });

    };

    const handleClick = () => {
        setSelectedIdp(data);
        setIdpId(data.id);
        setView(SsoView.Edit);
        history.push(`${path}/edit/${data.id}`);
    };

    const handleTestLoginRedirect = () => {
        //setLoading(true);
        setHasLaunched(false);
        //TODO post to oidc login endpoint and get redirect url
        //get redirect url from response
        fetchRedirectUrl().then(redirectUrl => {
            if (redirectUrl) {
            window.open(redirectUrl, '_blank');
            setHasLaunched(true);
            }
        });
    };

    return (
        <StyledTableRow>
            <StyledTableCell>
                <Button onClick={handleClick}>{display_name}</Button>
            </StyledTableCell>
            <StyledTableCell>{data.domain}</StyledTableCell>
            <StyledTableCell>{data.is_active ? 'Active' : 'Inactive'}</StyledTableCell>
            <StyledTableCell align="center">
                <Tooltip title={openTooltipTitle} onClick={onCopyURL} placement="left" arrow>
                    <OpenInNew onClick={handleTestLoginRedirect}/>
                </Tooltip>
                <Tooltip title={copyTooltipTitle} onClick={onCopyURL} placement="right" arrow>
                     <ContentCopy onClick={onCopyURL} />
                </Tooltip>

            </StyledTableCell>
        </StyledTableRow>
    );
};

export default SsoTableRow;
